import {
    jobsPerPage,
    revalidate,
    limitForBuild,
} from "../../../common/constants";
import { JobListing } from "../../../common/types";
import Poslovi from "../../../view/screens/Poslovi/Poslovi";
import { getAllJobsPerCity, handleGetJobsCount } from "../../api/job/get";

const cities = [
    {
        slug: "remote",
        name: "Remote",
    },
    {
        slug: "sarajevo",
        name: "Sarajevo",
    },
    {
        slug: "banja-luka",
        name: "Banja Luka",
    },
    {
        slug: "tuzla",
        name: "Tuzla",
    },
    {
        slug: "zenica",
        name: "Zenica",
    },
    {
        slug: "bijeljina",
        name: "Bijeljina",
    },
    {
        slug: "mostar",
        name: "Mostar",
    },
    {
        slug: "prijedor",
        name: "Prijedor",
    },
    {
        slug: "doboj",
        name: "Doboj",
    },
    {
        slug: "cazin",
        name: "Cazin",
    },
    {
        slug: "beograd",
        name: "Beograd",
    },
    {
        slug: "zagreb",
        name: "Zagreb",
    },
    {
        slug: "novi-sad",
        name: "Novi Sad",
    },
    {
        slug: "gradiska",
        name: "Gradiska",
    },
];

interface staticParams {
    params: {
        lokacija: string;
        page: string;
    };
}

interface citiesProps {
    jobs: JobListing[];
    name: string;
    page: number;
    total: number;
}

export default function Pocetna({ jobs, total, name, page }: citiesProps) {
    return (
        <Poslovi
            name={name}
            type="city"
            jobs={jobs}
            total={total}
            page={page}
        />
    );
}

export async function getStaticPaths() {
    const paths = [];

    for (const city of cities) {
        const jobsTotal = await handleGetJobsCount({
            jobs_cities: {
                some: {
                    cities: {
                        slug: city.slug,
                    },
                },
            },
        });

        const numOfPages = Math.ceil(jobsTotal / jobsPerPage);

        const cityPath = Array.from(Array(numOfPages).keys()).map((k) => ({
            params: { lokacija: city.slug, page: (k + 1).toString() },
        }));

        paths.push(cityPath);
    }

    const formattedPaths = paths.flat().slice(0, limitForBuild);

    return {
        paths: formattedPaths,
        fallback: "blocking",
    };
}

export async function getStaticProps({ params }: staticParams) {
    const { lokacija, page } = params;

    const intPage = parseInt(page, 10);

    const response = await getAllJobsPerCity({
        city: lokacija,
        perPage: jobsPerPage,
        page: intPage,
    });

    const name = cities.filter((city) => city.slug === lokacija);

    if (response.data) {
        return {
            props: {
                jobs: response.data,
                total: response.count,
                name: name[0].name,
                page: intPage,
            },
            revalidate: revalidate,
        };
    }
    if (!response.data) {
        return {
            notFound: true,
            revalidate: revalidate,
        };
    }
}
